import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./Firebase-Config"; // Adjust path to your config file

const PrivateRoutes = () => {
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Listens directly to Firebase Auth's initialization event
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false); // Auth is now fully initialized!
    });
    return () => unsubscribe();
  }, []);

  // Show a clean loading state during the 300ms initialization window
  if (loading) {
    return (
      <div style={styles.loading}>
        Establishing Secure Mvelio Session...
      </div>
    );
  }

  return user ? <Outlet /> : <Navigate to="/" />;
};

const styles = {
  loading: {
    height: "100vh",
    background: "#020617", // Matches Mvelio dark theme
    color: "#38bdf8", // Mvelio blue
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontFamily: "sans-serif",
    fontSize: "18px",
    fontWeight: "bold",
  }
};

export default PrivateRoutes;

